'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ProspectServiceCtrl
 * @description
 * # ProspectCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('Prospect', ['$http', 'domain', 'BaseService', 'toaster', function($http, domain, BaseService, toaster) {
    var BASE_PROSPECT_URL = domain.name + '/api/v1/prospects/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_PROSPECT_URL,
      baseModelName: 'prospect'
    });

    baseService.error = function(error) {
      if(error && error.status === 422) {
        // Foreach error
        if('name' in error.data.errors) {
          toaster.pop('error', 'Nombre', 'El nombre ' + error.data.errors.name);
        }
        if('drive_root_id' in error.data.errors) {
          toaster.pop('error', 'Ruta de Google', 'Favor de selecionar una ruta para el prospecto');
        }
        if('url' in error.data.errors) {
          toaster.pop('error', 'Url', 'Favor de verificar la ruta del prospecto.');
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
